import React from "react";
import { useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import "./Layout.css";

const Layout = ({ children }) => {
  const { pathname } = useLocation();
  const isSurvey = pathname === "/survey";

  return (
    <div className={`page-wrapper${isSurvey ? " survey-page" : ""}`}>
      <Header />
      <main className="page-main">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
